module.exports = __webpack_public_path__ + "img/phbanner.59d82641.png";